
interface IProps {
    title: string
    active: boolean
    onClick?: () => void
}

const SideNavMenuItem = ({ title, active, onClick }: IProps) => {
    return (
        <a
            className={active ? 'nav-link active' : 'nav-link'}
            onClick={() => {
                if (onClick)
                    onClick()
            }}>
            <span className='nav-link-text'>
                {title}
            </span>
        </a>
    )
}
export default SideNavMenuItem